import { useCallback, useState } from "react";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import {
  TeamifiedTask,
  useUpdateTaskMutation,
} from "../../../redux/Task/TaskApi";
import SplitButton from "../../../shared/components/CommonPageHeader/SplitButton";
import { userAccess } from "../../../utils/CommonFunction";
import CandidateMoveConfirmModal from "../../HireV3/CandidateMoveConfirmModal";
import { DISQUALIFICATION_REASON } from "../../HireV3/constants";

type Props = {
  candidate?: CandidateDetails;
  task?: TeamifiedTask & { taskId: number };
};

const OPTIONS = DISQUALIFICATION_REASON.map((option) => ({
  label: option.name,
  id: option.value,
}));

const DisqualifyCandidate = ({ candidate, task }: Props) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const [notifyCandidate, setNotifyCandidate] = useState<boolean>(true);

  const [reason, setReason] = useState<string>("");
  const [updateTask, updateTaskMutating] = useUpdateTaskMutation();
  const { userId, firstName, lastName } = userAccess();

  const submitRejectCandidate = useCallback(
    (tempReason?: string) => {
      if (task) {
        updateTask({
          ...task,
          id: task.taskId,
          completedAction: JSON.parse(task.actionsJson)[1].id,
          completedBy: userId,
          completedByName: firstName + " " + lastName,
          disquialifiedReason: tempReason ? tempReason : "",
          isrejectmail: !notifyCandidate,
        });
      }
    },
    [firstName, lastName, notifyCandidate, task, updateTask, userId],
  );

  const openModal = useCallback((id: string, checkboxValue?: boolean) => {
    setReason(id);
    setShowModal(true);
    setNotifyCandidate(checkboxValue ?? true);
  }, []);
  return (
    <>
      <CandidateMoveConfirmModal
        cancel={closeModal}
        isLoading={updateTaskMutating.isLoading}
        positiveResponse={submitRejectCandidate}
        showModal={showModal}
        text="Are you sure you want to disqualify this candidate?"
        btnText="Disqualify"
        reason={reason}
      ></CandidateMoveConfirmModal>
      <SplitButton
        options={OPTIONS}
        mainLabel="Disqualify"
        defaultSelectedId="Other"
        onSelect={openModal}
        variant="outlined"
        color="error"
        checkboxLabel="Notify candidate"
      />
    </>
  );
};

export default DisqualifyCandidate;
